
// producttion
export const basicurl = "https://api.applycae.com";

// staging
// export const basicurl = "https://backend.applycae.com";

// local
// export const basicurl = "http://localhost:8000";

export const token = window.sessionStorage.getItem("user_token");